import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

import router from '@/router';
import { useLocaleStore } from '@/store/locale';
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useThemeStore } from '@/store/theme';
import { Locale, Themes } from '@varlet/ui';
import { useRoute } from 'vue-router';
import LanguageComponent from '../GlobalComponents/LanguageComponent.vue';
import { useLanguageStatusStore } from '@/store/LanguageStatusStore';
import ClockComponent from '../GlobalComponents/ClockComponent.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const route = useRoute();
const locale = useLocaleStore();
const themeStore = useThemeStore();
const systemConfigStore = useSystemConfigStore();
const languageStatusStore = useLanguageStatusStore();
const messages = Locale.messages;

function SetTheme(themeKey: 'light' | 'dark') {
    themeStore.setTheme(themeKey);
}

/**
 * 返回
 */
function GoBack() {
    router.back();
}

return (_ctx: any,_cache: any) => {
  const _component_VarIcon = _resolveComponent("VarIcon")!
  const _component_VarButton = _resolveComponent("VarButton")!
  const _component_VarImage = _resolveComponent("VarImage")!
  const _component_VarSpace = _resolveComponent("VarSpace")!
  const _component_var_icon = _resolveComponent("var-icon")!
  const _component_var_button = _resolveComponent("var-button")!
  const _component_var_menu = _resolveComponent("var-menu")!
  const _component_var_app_bar = _resolveComponent("var-app-bar")!

  return (_openBlock(), _createBlock(_component_var_app_bar, {
    class: "top-header-body",
    "title-position": "center",
    title: _ctx.$t(_unref(route).meta.title as string)
  }, {
    left: _withCtx(() => [
      (!_unref(route).meta.noBack)
        ? (_openBlock(), _createBlock(_component_VarButton, {
            key: 0,
            color: "transparent",
            "text-color": "#fff",
            text: "",
            onClick: GoBack
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VarIcon, {
                name: "chevron-left",
                size: "24"
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_VarSpace, {
            key: 1,
            size: "5px",
            style: {"margin-left":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VarImage, {
                fit: "cover",
                radius: "50%",
                src: _ctx.$R(_unref(systemConfigStore).getConfig?.SystemLogo),
                height: "24"
              }, null, 8, ["src"]),
              _createElementVNode("span", null, _toDisplayString(_unref(systemConfigStore).config?.SystemName), 1)
            ]),
            _: 1
          }))
    ]),
    right: _withCtx(() => [
      _createVNode(ClockComponent, { style: {"font-size":"12px"} }),
      _createVNode(_component_var_button, {
        color: "transparent",
        "text-color": "#fff",
        round: "",
        text: ""
      }, {
        default: _withCtx(() => [
          (_unref(themeStore).getThemeName == 'dark')
            ? (_openBlock(), _createBlock(_component_var_icon, {
                key: 0,
                namespace: "icon",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (SetTheme('light'))),
                name: "yejing",
                size: 20
              }))
            : (_openBlock(), _createBlock(_component_var_icon, {
                key: 1,
                namespace: "icon",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (SetTheme('dark'))),
                name: "lieri",
                size: 20
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_var_menu, {
        show: _unref(languageStatusStore).show,
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_unref(languageStatusStore).show) = $event)),
        placement: "bottom-end"
      }, {
        menu: _withCtx(() => [
          _createVNode(LanguageComponent)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_var_button, {
            color: "transparent",
            "text-color": "#fff",
            round: "",
            text: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_var_icon, {
                namespace: "icon",
                name: "duoyuyan",
                size: 24
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})